import { queryUser } from '../graphql-client';
import type { ContentVersion, Version } from './types';

export const GET_CONTENT_VERSION_LIST = /* GraphQL */ `
  query getContentVersionList($id: ID!, $from: Int, $size: Int) {
    result: getContentVersionList(id: $id, from: $from, size: $size) {
      total
      from
      size
      items {
        id
        version
        status
        enabled
        color
        updatedAt
        updatedBy {
          id
          fullName
          email
          role
          avatarPath
        }
      }
    }
  }
`;

export const GET_CONTENT_VERSION = /* GraphQL */ `
  query getContentVersion($id: ID!, $version: Int!, $locale: String!, $enableLocaleFallback: Boolean) {
    result: getContentVersion(
      id: $id
      version: $version
      locale: $locale
      enableLocaleFallback: $enableLocaleFallback
    ) {
      content
      schema
    }
  }
`;

export const getContentVersionList = async (id: string, from = 0, size = 10): Promise<Version[]> => {
  return queryUser<Version[]>(GET_CONTENT_VERSION_LIST)({ id, from, size });
};

export const getContentVersion = async (
  id: string,
  version: number,
  locale: string,
  enableLocaleFallback = true
): Promise<ContentVersion> => {
  return queryUser<ContentVersion>(GET_CONTENT_VERSION)({
    id,
    version,
    locale,
    enableLocaleFallback
  });
};
